/**
 * Semantic colour token map.
 *
 * Groups the canonical `design-tokens/colors` palette by role (text, bg, forms, status). The MUI
 * palette is built straight from `colors`, and `theme/components/forms.ts` reads the palette rather
 * than these groups. Prefer palette paths (`text.secondary`, `grey.200`) in `sx` over reaching for
 * these tokens directly.
 */

import { colors } from "./colors";

const success = {
  100: colors.success[600],
  200: colors.success[800],
};

const info = {
  100: colors.blue[500],
  200: colors.blue[800],
};

const warning = {
  100: colors.warning[500],
  200: colors.warning[700],
};

const error = {
  100: colors.critical[500],
  200: colors.critical[700],
};

export const themeColors = {
  trueWhite: colors.white,
  white: colors.neutrals[50],
  black: colors.neutrals[900],
  primary: colors.navy[800],
  secondary: {
    100: colors.blue[500],
    200: colors.blue[800],
  },
  accent: {
    100: colors.critical[500],
    200: colors.critical[700],
  },
  highlight: {
    200: colors.aqua[600],
  },
  muted: {
    100: colors.neutrals[50],
    200: colors.neutrals[100],
    300: colors.neutrals[200],
    400: colors.neutrals[500],
  },
  success,
  info,
  warning,
  error,
  danger: error,
  text: {
    body: colors.neutrals[900],
    light: colors.neutrals[50],
    muted: colors.neutrals[600],
    heading: colors.navy[800],
    link: colors.aqua[600],
    accent: colors.critical[700],
    success: colors.success[800],
    info: info[200],
    warning: warning[200],
    error: error[200],
    disabled: colors.neutrals[500],
  },
  bg: {
    light: colors.neutrals[50],
    content: colors.neutrals[100],
    dark: colors.neutrals[200],
  },
  forms: {
    inputBg: colors.white,
    inputDisabledBg: colors.neutrals[100],
    inputColor: colors.neutrals[900],
    inputBorderColor: colors.neutrals[200],
    hoverBorderColor: colors.aqua[600],
    focusBorderColor: colors.aqua[600],
    focusShadowColor: colors.aqua[100],
    errorBorderColor: colors.critical[700],
    errorFocusShadowColor: "rgba(179, 0, 57, 0.15)",
  },
};
